import { graphql, useStaticQuery } from 'gatsby';

export const useFields = () => {
  const { wrapper } = useStaticQuery(graphql`
    query {
      wrapper: allAirtableFields(sort: {fields: rowIndex}) {
        nodes {
          data {
            Decimals
            Description
            Key
            Label
            Ressource
            ShowInList
            Suffix
          }
        }
      }
    }
  `);

  return wrapper.nodes;
};

// Match old `helpers/fields.js` structure
export const useFieldsObject = () =>
  useFields()
    .map(({ data }) => data)
    .reduce((acc, { Key, Label, Description, Suffix, Decimals }) => ({
      ...acc,
      [Key]: { short: Label, long: Description, suffix: Suffix, round: Decimals },
    }), {});

export default useFields;
